import { FirstAider } from "../interfaces/FirstAider";

export function sortFirstAidersList(list: Array<FirstAider>): Array<FirstAider> {
    const isFirstAiderAvailable = (availability: unknown): boolean => {
        return availability === true || availability === "true";
    };

    const sortByFullName = (first: FirstAider, second: FirstAider) => {
        const firstFullName = `${first.name} ${first.surname}`;
        const secondFullName = `${second.name} ${second.surname}`;

        return firstFullName.localeCompare(secondFullName);
    };
    const availableWithPhone = list
        .filter(firstAider => isFirstAiderAvailable(firstAider.availability) && firstAider.phone.trim().length > 0)
        .sort(sortByFullName);
    const availableWithoutPhone = list
        .filter(firstAider => isFirstAiderAvailable(firstAider.availability) && firstAider.phone.trim().length === 0)
        .sort(sortByFullName);
    const unavailable = list
        .filter(firstAider => !isFirstAiderAvailable(firstAider.availability))
        .sort(sortByFullName);

    return [...availableWithPhone, ...availableWithoutPhone, ...unavailable];
}
